"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Sparkles, Wind, HeartPulse, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function WasIstChakraHeilung() {
  const shouldReduceMotion = useReducedMotion();
  const animationProps = shouldReduceMotion ? {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 1
    }
  } : {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.2
    },
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  };
  return <section id="waschakraheilung" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border/40 isolate">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <motion.div {...animationProps} className="mx-auto max-w-3xl text-center space-y-4 mb-12 md:mb-16">
          <div>
            <Badge variant="secondary" className="text-secondary-foreground font-normal tracking-wide">
              Grundlagen
            </Badge>
          </div>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[36px] font-normal leading-tight text-foreground text-balance">
            Was ist Chakra Reinigung und Chakra Heilung?
          </h2>

          <p className="font-sans text-muted-foreground text-sm sm:text-base leading-relaxed text-balance">
            Chakren sind Energiezentren, über die nach alter Überlieferung unsere Lebensenergie fliesst. Durch Stress, Belastungen und unverarbeitete Erlebnisse kann dieser Fluss ins Stocken geraten. Reinigung und Heilung greifen an dieser Stelle ineinander.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          <motion.div {...animationProps} transition={{
          duration: 0.5,
          ease: "easeOut",
          delay: shouldReduceMotion ? 0 : 0.1
        }}>
            <Card className="h-full border-border/70 bg-card shadow-xs transition-[border-color,box-shadow] duration-200 hover:border-primary/40 hover:shadow-sm">
              <CardContent className="p-6 sm:p-8 flex flex-col justify-between h-full space-y-4">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center size-10 rounded-lg bg-secondary text-secondary-foreground shrink-0 shadow-2xs">
                      <Wind className="size-5 text-primary" />
                    </div>
                    <h3 className="font-sans text-xl font-bold text-foreground">
                      Chakra Reinigung
                    </h3>
                  </div>
                  <p className="font-sans text-sm sm:text-base text-muted-foreground leading-relaxed">
                    Die Reinigung löst energetische Blockaden und angestaute Anspannung. Sie schafft Raum, damit deine Energie wieder frei fliessen kann und du dich leichter und klarer fühlst.
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>

          <motion.div {...animationProps} transition={{
          duration: 0.5,
          ease: "easeOut",
          delay: shouldReduceMotion ? 0 : 0.2
        }}>
            <Card className="h-full border-border/70 bg-card shadow-xs transition-[border-color,box-shadow] duration-200 hover:border-primary/40 hover:shadow-sm">
              <CardContent className="p-6 sm:p-8 flex flex-col justify-between h-full space-y-4">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center size-10 rounded-lg bg-secondary text-secondary-foreground shrink-0 shadow-2xs">
                      <HeartPulse className="size-5 text-primary" />
                    </div>
                    <h3 className="font-sans text-xl font-bold text-foreground">
                      Chakra Heilung
                    </h3>
                  </div>
                  <p className="font-sans text-sm sm:text-base text-muted-foreground leading-relaxed">
                    Die Heilung harmonisiert und stärkt deine Energiezentren nachhaltig. Sie unterstützt dich dabei, emotionale und körperliche Balance zu finden und im Alltag geerdet zu bleiben.
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>

        <motion.div {...animationProps} transition={{
        duration: 0.5,
        ease: "easeOut",
        delay: shouldReduceMotion ? 0 : 0.3
      }} className="mt-12 text-center space-y-6 max-w-2xl mx-auto">
          <p className="font-sans text-sm sm:text-base text-foreground font-medium leading-relaxed">
            Zusammen bilden beide einen sanften Weg: erst loslassen, dann stärken und neu ausrichten.
          </p>

          <div>
            <Button asChild size="lg" className="shadow-xs gap-2">
              <Link to="/ContactPage">
                <span>Termin anfragen</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}